import { arrayOf, bool, object, shape, string } from 'prop-types';
import React, { Fragment } from 'react';
import BaseRecipe from 'components/Recipe';
import LazyLoad from 'components/LazyLoad';
import Ad from 'components/Ad';
import Chicory from 'components/Chicory';
import Comment from 'components/Icons/Comment';
import RecipePrintButton from 'components/RecipePrintButton';
import RecipeRating from 'components/RecipeRating';
import RecipeRatingsDataProvider from 'components/RecipeRatingsDataProvider';
import RecipeSupplyAffiliateLinkDataProvider from 'components/RecipeSupplyAffiliateLinkDataProvider';
import { RECIPE_AD_SIZE_MAPPING } from 'constants/ads/sizes';
import { BASE_AD_UNITS } from 'constants/ads/units';
import styles, { recipeStyles } from './styles';

function SiteRecipe(props) {
  const {
    recipeId,
    post,
    supplyGroups: baseSupplyGroups,
    hideAds,
    hideComments,
    hideAccountActions
  } = props;

  const targeting = post && post.ads ? post.ads.targeting : undefined;

  const ingredientsAddOn =
    post && !post.isSponsored ? (
      <LazyLoad height={0} offset={300} once>
        <Chicory canonical={post.canonical} />
      </LazyLoad>
    ) : null;

  return (
    <div className="SiteRecipe" data-porkchop-id={recipeId}>
      {!hideAds && (
        <Ad
          sizes={RECIPE_AD_SIZE_MAPPING}
          unit={`${BASE_AD_UNITS.recipe}/Embed`}
          targeting={targeting}
        />
      )}

      <RecipeRatingsDataProvider recipeId={recipeId}>
        {({
          ratingsData,
          rateRecipe,
          rateRecipeIsLoading,
          fetchUserRating
        }) => (
          <Fragment>
            <div className="SiteRecipe__interactions">
              <RecipePrintButton {...props} placement="in-post" />
              {!hideComments && (
                <a
                  className="SiteRecipe__jumpToComments"
                  href={`#comments-${post.resourceId}`}
                  data-gtm-placement="recipe"
                  data-gtm-social-network="community"
                >
                  <Comment display="inline-block" isOutlined />
                  Comments
                </a>
              )}
              {!hideAccountActions && ratingsData && (
                <RecipeRating
                  ratingsData={ratingsData}
                  rateRecipe={rateRecipe}
                  rateRecipeIsLoading={rateRecipeIsLoading}
                  recipeId={parseInt(recipeId, 10)}
                  fetchUserRating={fetchUserRating}
                />
              )}
            </div>

            <RecipeSupplyAffiliateLinkDataProvider
              supplyGroups={baseSupplyGroups}
            >
              {({ supplyGroups }) => (
                <BaseRecipe
                  {...props}
                  ratingsData={ratingsData}
                  supplyGroups={supplyGroups}
                  ingredientsAddOn={ingredientsAddOn}
                  showNutrition
                  placement="inPost"
                  styles={recipeStyles}
                />
              )}
            </RecipeSupplyAffiliateLinkDataProvider>
          </Fragment>
        )}
      </RecipeRatingsDataProvider>
      <style jsx>{styles}</style>
    </div>
  );
}

SiteRecipe.defaultProps = {
  post: undefined,
  supplyGroups: [],
  hideAds: false,
  hideComments: false
};

SiteRecipe.propTypes = {
  title: string.isRequired,
  recipeId: string.isRequired,
  post: shape({
    canonical: string.isRequired,
    ads: shape({
      targeting: object,
      tags: arrayOf(string)
    })
  }),

  // only describing locally-relevant props for addAffiliateLinksToSupplies()
  supplyGroups: arrayOf(
    shape({
      items: arrayOf(
        shape({
          affiliateLink: shape({
            url: string
          })
        })
      )
    })
  ),

  hideAds: bool,
  hideComments: bool,
  hideAccountActions: bool
};

export default SiteRecipe;
